import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { techdocsFeedbackApiRef } from './api/TechDocsFeedbackApi';
import { TechDocsFeedbackClient } from './api/TechDocsFeedbackClient';
import { withEnvGuard } from '@traton/devportal-env-kit-app';

export const techdocsFeedbackPlugin = createPlugin({
  id: 'techdocs-feedback',
  apis: [
    createApiFactory({
      api: techdocsFeedbackApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechDocsFeedbackClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const TechDocsFeedbackPage = techdocsFeedbackPlugin.provide(
  createRoutableExtension({
    name: 'TechDocsFeedbackPage',
    component: () =>
      import('./components/TechDocsFeedbackPage').then(m =>
        withEnvGuard(m.TechDocsFeedbackPage, 'techdocs-feedback'),
      ),
    mountPoint: rootRouteRef,
  }),
);
